<template>
  <div class="portal-content overflow-hidden" @click="$emit('clickCard')">
    <div class="tag">{{ label }}</div>
    <div class="flex flex-1 flex-col pr-4">
      <span class="text-xl w-full font-semibold text-white truncate title">{{
        content.title
      }}</span>
      <span class="w-full text-base text-white pt-3 truncate-two">{{ content.desc }} </span>
    </div>
    <div class="flex justify-end icon md:mr-4">
      <img src="./assets/portal.svg" />
    </div>
  </div>
</template>

<script lang="ts">
import { Content, Sequence } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PortalCard extends Vue {
  @Prop({ type: Object }) content!: Content;
  @Prop({ type: String, default: '练习' }) label!: string;
}
</script>

<style scoped>
.tag {
  @apply absolute flex items-center justify-center pl-2 pr-3 h-6 top-2 left-0 bg-green-300 text-white;
  border-radius: 0px 12px 12px 0px;
}
.portal-content {
  @apply relative flex items-center justify-between w-full sm:w-4/5 md:w-112 h-40 md:mt-8 mb-4 md:ml-12 p-6 pt-10 hover:shadow-lg rounded-motif cursor-pointer;
  background: linear-gradient(90.6deg, #64b5f0 0.61%, #78c2ec 98.08%);
  transition: transform 0.3s linear;
}

.portal-content:hover {
  transform: translateY(-0.25rem);
}

.truncate-two {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
}
.title {
  @apply relative;
}
.icon {
  flex: 0 0 8rem;
}
</style>
